(function(angular) {

    angular.module('GorillaBoy.Search')
    .controller('SearchController', [
        '$scope',
        '$rootScope',
        '$routeParams',
        '$log',
        '$location',
        '$sce',
        '$translate',
        '$timeout',
        '$q',
        'SearchService',
        'SearchV2Service',
        'UserCollectionService',
        'SessionManager',
        'ContentTypeFormatter',
        'LayoutManager',
        'FileManagerFactory',
        'FileService',
        'View',
        'MessageProvider',
        'MessageManager',
        'DocumentService',
        'SourceConstant',
        'SortService',
        'AppConstants',
        'userInfo',
        'CheckinCheckoutController',
        'BaseFileBrowserController',
        'Favorites',
        'FeatureManagerService',
        'Features',
        'SignalProvider',
        'QuerySearchManager',
        'CompanionService',
        SearchController
    ]);

    function SearchController($scope, $rootScope, $routeParams, $log, $location, $sce, $translate, $timeout, $q, SearchService, SearchV2Service, UserCollectionService,
        SessionManager, ContentTypeFormatter, LayoutManager, FileManagerFactory, fileService, View, MessageProvider, MessageManager, DocumentService, SourceConstant,
        SortService, AppConstants, userInfo, CheckinCheckoutController, BaseFileBrowserController, Favorites, FeatureManagerService, Features, SignalProvider, QuerySearchManager, CompanionService) {

        // AppConstant bindings
        var viewTypes = AppConstants.ViewTypes,
            galleryTypes = AppConstants.GalleryTypes,
            layoutViewTypes = AppConstants.LayoutViewTypes;

        BaseFileBrowserController.initScope($scope, View, userInfo);
        CheckinCheckoutController.initScope($scope, userInfo);

        var fileManager = new FileManagerFactory.FileManager();
        $scope.$on("$destroy", function() {
            fileManager.destroy();
        });

        $scope.fileManagerInstance = fileManager;

        activate();

        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate() {
            $log.debug(new Date().toISOString() + ' [SearchController] Initiating…');

            FileManagerFactory.setUserContext(userInfo);
            $rootScope.preFetchSharedWithMeDebounced();
            SessionManager.setCurrentView(viewTypes.SEARCH_TYPE);

            // SECTION: Layout code
            $scope.layout = {
                partialContent: './file-browser/content_partial.html',
                partialModals: null,
                partialTitleBar: './file-browser/title_bar.html',
                view: View,
                //Master copy of whether left sidebar should be shown/hidden.
                showLeftSidebar: $rootScope.showLeftSidebar,
                hasRightSidebar: false,
                showRightSidebar: false,
                showUploadPane: false
            };
            $rootScope.metricServiceInstance.putMetric({
                MethodName: "Search.PageVisit",
                MetricName: "Count",
                Unit: "Count",
                Values: 1
            });
            $scope.folderState = {
                view: View,
                viewType: SessionManager.getPreferred(),
                hideOwnerCaption: false
            };
            $scope.actionBar = {
                canOpen: true,
                canOpenContainingFolder: true,
                /*
                canEdit: false,
                canShare: false,
                canDelete: false,
                canMove: false,
                canDownload: false,
                canRename: false,
                canRemoveFromShare: false,
                */
                resourceType: null
            };
            $scope.pageSize = 50;
            $scope.userInfo = userInfo;
            $scope.isSearchV2Enabled = FeatureManagerService.isFeatureEnabled(Features.UI.SEARCH_V2);
            $scope.folders = [];
            $scope.documents = [];
            $scope.resourceMap ={};
            $scope.selectedFileCount = 0;
            $scope.filter = 'ALL';
            $scope.hasFilters = true;
            $scope.urlParams = $location.search();
            $scope.keywordsMap = QuerySearchManager.parseNormalizedQueryToKeywordsMap(decodeURIComponent($scope.urlParams.query));
            $scope.keywordsOptionsValue = _.clone($scope.urlParams);
            delete $scope.keywordsOptionsValue.query;
            $scope.queryString = ($scope.isSearchV2Enabled)? $scope.keywordsMap.search_text
                                          : decodeURIComponent($scope.sanitizeQuery($routeParams.queryString));
            $scope.SortOrder = SortService.CONSTANTS.ORDER;
            $scope.SORT_BY = SortService.CONSTANTS.SORT_BY;
            $scope.sortOptions = SortService.getDefaultSortOptions(viewTypes.SEARCH_TYPE);
            $scope.sortOption = SortService.getSortOption(viewTypes.SEARCH_TYPE, $scope.folderState.viewType);

            // Maping sort attributes from SearchV2 to SearchV1, if feature is not enabled
            if (!$scope.isSearchV2Enabled) {
                var RECENCY_INDEX = 0, NAME_INDEX = 1, TYPE_INDEX = 3;
                $scope.sortOptions[RECENCY_INDEX].orderBy = SortService.CONSTANTS.SEARCH_ORDER_BY.DATE;
                $scope.sortOptions[NAME_INDEX].orderBy = SortService.CONSTANTS.SEARCH_ORDER_BY.ALPHABETICAL;
                $scope.sortOptions[TYPE_INDEX].orderBy = SortService.CONSTANTS.SEARCH_ORDER_BY.TYPE;

                if ($scope.sortOption.orderBy == SortService.CONSTANTS.SEARCH_ORDER_BY.MODIFIED_TIMESTAMP) {
                  $scope.sortOption.orderBy = SortService.CONSTANTS.SEARCH_ORDER_BY.DATE;
                } else if ($scope.sortOption.orderBy == SortService.CONSTANTS.SEARCH_ORDER_BY.NAME) {
                  $scope.sortOption.order = SortService.CONSTANTS.SEARCH_ORDER_BY.ALPHABETICAL;
                } else if ($scope.sortOption.orderBy == SortService.CONSTANTS.SEARCH_ORDER_BY.CONTENT_TYPE) {
                  $scope.sortOption.order = SortService.CONSTANTS.SEARCH_ORDER_BY.TYPE;
                }
            }

            $scope.contentLoadingPromise = null;
            $scope.ViewTypes = viewTypes;
            $scope.GalleryTypes = galleryTypes;

            LayoutManager.is(View, $scope);
            $scope.clickedOnResource  = function(resource) {
                $rootScope.metricServiceInstance.putMetric({
                    MethodName: "Search.ClickedOnResource",
                    MetricName: "Count",
                    Unit: "Count",
                    Values: 1
                });
            };

            $scope.hasDeletePermission = function() {
                return false;
            };

            $scope.downloadFolder = function(folder) {
                CompanionService.downloadFolder(folder);
            };

            $scope.clickList = function() {
                $scope.folderState.viewType = SessionManager.setPreferred(galleryTypes.LIST_VIEWTYPE);
            };

            $scope.clickThumbnail = function() {
                $scope.folderState.viewType = SessionManager.setPreferred(galleryTypes.THUMBNAIL_VIEWTYPE);
            };

            $scope.getVersionDownload = function(documentId, documentVersionId) {
                DocumentService.getDocumentVersionSource(documentId, documentVersionId, null)
                .success(function(data) {
                    var source = data.Metadata.Source,
                        sourceUrl = source.ORIGINAL;
                    $scope.documentSourceUrl = $sce.trustAsResourceUrl(sourceUrl);
                });
            };

            $scope.isOfficeLegacyFile = function(resource){
                if (!resource.VersionMetadata) {
                    return;
                }
                return ContentTypeFormatter.isOfficeLegacyFile(resource.VersionMetadata.ContentType);
            };

            $scope.getShareLinkTooltip = function(resourceType) {
            	if (resourceType === 'folder') {
            		return $translate.instant('SHARE_LINK.DOCUMENT_VIEWER.FOLDER_LINK_TOOLTIP');
            	} else if (resourceType === 'document') {
            		return $translate.instant('SHARE_LINK.DOCUMENT_VIEWER.DOCUMENT_LINK_TOOLTIP');
            	}
            };

            $scope.inRootLayout = function() {
                return true;
            };

            $scope.showEmptyMessage = function() {
                return $scope.documents && $scope.documents.length === 0 &&
                       $scope.folders && $scope.folders.length === 0 &&
                       $scope.folderState.loaded;
            };

            $scope.changeSortOrder = function(option, currentSortOrder) {
                $log.debug("changeSortOrder called with option : " + JSON.stringify(option) + "; current Sort order : " + currentSortOrder);
                if ($scope.isSearchV2Enabled) {
                    changeSortOrderV2(option);
                } else {
                    changeSortOrderV1(option);
                }
                SortService.setSortOption(viewTypes.SEARCH_TYPE, $scope.folderState.viewType, option);
            };

            /*
            * Search API V1 only supports search of files
            * and doesn't support ASC, DESC order
            */
            $scope.searchDocuments = function(filter, order) {
                $scope.filter = filter;
                var done = $q.defer();
                $scope.folderState.loaded = false;
                var serverOrderBy = (order === 'TYPE') ? undefined : order;
                $log.info("Searching for documents. Query: " + $scope.queryString);
                if ($scope.queryString.length > 0) {
                    var params = {
                        userId: encodeURI(userInfo.Id),
                        orderBy: serverOrderBy,
                        query: $scope.queryString,
                        filter: $scope.filter
                    };
                    $scope.documents = [];
                    SearchService.searchDocuments(params)
                    .success(function(data) {
                        data = angular.fromJson(data);
                        if (data.Documents) {
                            data.Documents = data.Documents.map(function(doc) {
                                doc.Owner.ProfilePhotoThumbnails = doc.Owner.ProfilePhotoMetadata.ProfilePhotoThumbnails;
                                return doc;
                            });
                            $scope.fileManagerInstance.setFiles(data.Documents);
                            $scope.documents = data.Documents;
                            $scope.getCheckoutUsersInfo($scope.documents);
                        }
                        $scope.folderState.emptyMessage = MessageProvider.emptyMessageSearch($scope.queryString);
                        $scope.folderState.loaded = true;
                        $scope.applyFavorites($scope.documents, [], Favorites);
                        if(order === "TYPE"){
                            $log.debug("Calling client side sort to sort by type");
                            $scope.changeSortOrder($scope.sortOptions[3], $scope.sortOrder);
                        }
                        done.resolve();
                    })
                    .error(function(data, status, headers, config) {
                        if (status === 500) {
                            MessageManager.addErrorMessage(MessageProvider.searchFailDefault);
                        }
                        done.reject();
                    });
                } else {
                    $scope.documents = [];
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageEmptySearchQuery;
                    $scope.folderState.loaded = true;
                }

                switch (filter) {
                    case viewTypes.SHARED_TYPE:
                        $scope.myDocumentsStyle = '';
                        $scope.sharedWithMeStyle = 'active';
                        $scope.allStyle = '';
                        $scope.filterText = $translate.instant('LEFT_NAV.SHARED_WITH_ME');
                        $scope.isShared = true;
                        break;
                    case viewTypes.OWN_TYPE:
                        $scope.myDocumentsStyle = 'active';
                        $scope.sharedWithMeStyle = '';
                        $scope.allStyle = '';
                        $scope.filterText = $translate.instant('LEFT_NAV.MY_DOCUMENTS');
                        $scope.isShared = false;
                        break;
                    case viewTypes.ALL_TYPE:
                        $scope.myDocumentsStyle = '';
                        $scope.sharedWithMeStyle = '';
                        $scope.allStyle = 'active';
                        $scope.filterText = $translate.instant('TOP_NAV.ALL_RESULTS');
                        $scope.isShared = true;
                }
                return done.promise;
            };

            /*
            * Search V2
            */
            $scope.searchResources = function() {

                var done = $q.defer();
                $scope.folderState.loaded = false;
                $log.info("Searching for resources. Query: " + decodeURIComponent($scope.urlParams.query));
                if ($scope.urlParams.query) {

                    SearchV2Service.searchResources($scope.queryString, $scope.sortOption, $scope.queryAdvanceOptions, null, $scope.pageSize)
                    .success(function(data) {
                        data = angular.fromJson(data);
                        data = removeDuplicates(data);

                        if (data.Folders) {
                            $scope.folders = data.Folders;
                            $scope.fileManagerInstance.setFolders($scope.folders);
                        }
                        if (data.Documents) {
                            $scope.documents = data.Documents;
                            $scope.fileManagerInstance.setFiles($scope.documents);
                            $scope.getCheckoutUsersInfo($scope.documents);
                        }

                        $scope.applyFavorites($scope.documents, $scope.folders, Favorites);
                        $scope.fileManagerInstance.setPagingMarker(data.Marker);
                        $scope.folderState.emptyMessage = MessageProvider.emptyMessageSearch($scope.queryString);
                        $scope.folderState.loaded = true;
                        done.resolve();
                    })
                    .error(function(data, status, headers, config) {
                        if (status === 500) {
                            MessageManager.addErrorMessage(MessageProvider.searchFailDefault);
                        }
                        done.reject();
                    });

                } else {
                    $scope.folders = [];
                    $scope.documents = [];
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageEmptySearchQuery;
                    $scope.folderState.loaded = true;
                }

                return done.promise;
            };

            // Removes documents and folders which have already appeared in previous pages
            function removeDuplicates(serviceResponse) {
                for (var docIdx = serviceResponse.Documents.length - 1; docIdx >= 0; docIdx--) {
                  if ($scope.resourceMap[serviceResponse.Documents[docIdx].Id]){
                      serviceResponse.Documents.splice(docIdx, 1);
                  }
                }
                for (var folderIdx = serviceResponse.Folders.length - 1; folderIdx >= 0; folderIdx--) {
                  if ($scope.resourceMap[serviceResponse.Folders[folderIdx].Id]){
                      serviceResponse.Folders.splice(folderIdx, 1);
                  }
                }

                serviceResponse.Documents.forEach(function(document) {
                    $scope.resourceMap[document.Id] = document;
                });
                serviceResponse.Folders.forEach(function(folder) {
                    $scope.resourceMap[folder.Id] = folder;
                });

                return serviceResponse;
            }

            $scope.loadMoreSearchResources = function() {
                if ($scope.contentLoadingPromise !== null || !$scope.fileManagerInstance.getMarker()) {
                    return $scope.contentLoadingPromise;
                }
                var deferred = $q.defer();
                $rootScope.$broadcast(SignalProvider.ContentLoading.Start);

                SearchV2Service.searchResources($scope.queryString, $scope.sortOption, $scope.queryAdvanceOptions, $scope.fileManagerInstance.getMarker(), $scope.pageSize)
                .success(function(data) {

                  data = removeDuplicates(data);

                  var documentsInPage = data.Documents;
                      foldersInPage = data.Folders;

                  $scope.applyFavorites(documentsInPage, foldersInPage, Favorites);
                  $scope.getCheckoutUsersInfo(documentsInPage);

                  $scope.fileManagerInstance.appendFilesAndFolders(data);
                  $scope.fileManagerInstance.setPagingMarker(data.Marker);

                  $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                  deferred.resolve();
                })
                .error(function(data, status, headers, config) {
                  $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                  deferred.reject(response);
                });

                $scope.contentLoadingPromise = deferred.promise;
                $scope.contentLoadingPromise.finally(function() {
                    $scope.contentLoadingPromise = null;
                });
                return $scope.contentLoadingPromise;
            };

            // Used for pagination in SearchV2 API
            $scope.$on(SignalProvider.ContentLoading.LoadMore, function($event, data) {
                $scope.loadMoreSearchResources();
                $event.stopPropagation();
            });

            // Executed below
            var searchQuery = (!$scope.isSearchV2Enabled)? $scope.queryString
                        : QuerySearchManager.translateQuery(decodeURIComponent($scope.urlParams.query));
            $scope.resultsTitle = $translate.instant('SEARCH.RESULTS_TITLE', {
                query: searchQuery
            });
            // Replace html entities (like &amp;) to its corresponding string (&amp; -> &)
            $scope.resultsTitle = _.unescape($scope.resultsTitle);

            // MAIN
            document.title = $scope.resultsTitle + ' - ' + AppConstants.APP_NAME;
            if ($scope.isSearchV2Enabled) {

                delete $scope.keywordsMap.search_text;
                QuerySearchManager.getAdvanceOptionsPromise($scope.keywordsMap, $scope.keywordsOptionsValue)
                .then(function (responses) {
                    var advanceOptions = QuerySearchManager.mapAdvanceOptionsResponsesToRequest(responses);
                    $scope.queryAdvanceOptions = advanceOptions;

                    // Override $scope.sortOption retrived by SortService
                    // if user gave an explicit sort option as a keywords
                    var sortOption = QuerySearchManager.mapSortOptionResponsesToRequest(responses);
                    if (sortOption) {
                      $scope.sortOption = sortOption;

                    } else {
                      // If there is a search term, sort by RELEVANCE.
                      // Otherwise, sort by the value retrieved in sort service
                      $scope.sortOption = ($scope.queryString)?  $scope.sortOptions[4] : $scope.sortOption;
                    }

                    $scope.searchResources();
                });

            } else if ($scope.sortOption.orderBy === 'TYPE') {
                $scope.searchDocuments('ALL', 'RELEVANCE').then(function success() {
                    $('.filterResults').addClass('inactive');
                    $scope.documents.sort(function(document1, document2) {
                        var type1 = ContentTypeFormatter.getTypeCategory(document1.VersionMetadata.ContentType);
                        var type2 = ContentTypeFormatter.getTypeCategory(document2.VersionMetadata.ContentType);
                        return type1.localeCompare(type2);
                    });
                });
            } else {
                $scope.searchDocuments('ALL', $scope.sortOption.orderBy);
            }

            var lastSearch;
            if ($scope.isSearchV2Enabled) {
                lastSearch = "*?query=" + $scope.urlParams.query;
            } else {
                lastSearch = $scope.queryString;
            }
            SessionManager.setLastSearched(lastSearch);

        }

        /*
        * Change sort order for Search API v1
        */
        function changeSortOrderV1(option) {
            if ($scope.sortOption) {
                if ($scope.sortOption.text !== option.text) {
                    // if choosing different sort criterion, choose that criterion's default sort order
                    $scope.sortOption = option;
                }

                if ($scope.sortOption.name === 'TYPE') {
                    $scope.documents.sort(function(document1, document2) {
                        var type1 = ContentTypeFormatter.getTypeCategory(document1.VersionMetadata.ContentType);
                        var type2 = ContentTypeFormatter.getTypeCategory(document2.VersionMetadata.ContentType);
                        return type1.localeCompare(type2);
                    });
                } else {
                    $scope.searchDocuments($scope.filter, $scope.sortOption.orderBy);
                }
            }
        }

        /*
        * Change sort order for SearchV2 API
        */
        function changeSortOrderV2(option) {
            // Every time we sort by attribute, we need to clean the resourceMap object,
            // which stores duplicated ID of resources from SearchV2 response
            $scope.resourceMap = {};
            if ($scope.sortOption.text !== option.text) {
                // if choosing different sort criterion, choose that criterion's default sort order
                $scope.sortOption = option;
                $scope.sortOrder = option.order;
            } else {
                // otherwise, just flip the order
                $scope.sortOrder = SortService.getOppositeOrder($scope.sortOrder);
                $scope.sortOption.order = $scope.sortOrder;
            }
            $scope.searchResources();
        }
    }
}(angular));
